import { GeneralModel } from ".";

export class CalculateBy extends GeneralModel {
}